import request from '@/utils/request';
import type { Task } from './types';
import { type ReqReturn } from '@/utils/catch';
import type { AxiosResponse } from 'axios';

/** 获取当前已经完成的任务 - 弹窗 */
export const getUnclaimedTask = (): Promise<ReqReturn> => {
  return request({
    url: `/uc/api/v1/task/unclaimed`,
    method: 'get',
    params: {}
  });
};

/** 获取签到状态 */
export const getSignStatus = (): Promise<any> => {
  return request({
    url: `/uc/api/v1/task/sign_status`,
    method: 'get',
    params: {}
  });
};
// 首页获取签到状态 不会跳转401
export const getSignStatusUnLogin = (): Promise<any> => {
  return request({
    url: `/uc/api/v1/task/v2/sign_status`,
    method: 'get',
    data: {}
  });
};
/** 签到 */
export const signIn = (): Promise<any> => {
  return request({
    url: `/uc/api/v1/task/sign-in`,
    method: 'post',
    data: {}
  });
};

export const getUncompletedTask = (params: object): Promise<AxiosResponse<Task[]>> => {
  return request({
    url: `/uc/api/v1/task/uncompleted`,
    method: 'get',
    params
  });
};

export const getUncompletedTaskV2 = (params: object): Promise<AxiosResponse<{
  starter_task: Task[]
  daily_task: Task[]
  normal_task: Task[]
}>> => {
  return request({
    url: `/uc/api/v1/task/v2/uncompleted`,
    method: 'get',
    params
  });
};

/**
 * 领取积分任务奖励
 * @param taskId 任务ID
 * @returns {Promise}
 */
export const getTaskPoints = (taskId: number): Promise<AxiosResponse<unknown>> => {
  return request({
    url: `/uc/api/v1/task/${taskId}/points`,
    method: 'post'
  });
};

// 获取任务详情
export const getTaskDetail = (taskName: string): Promise<AxiosResponse<unknown>> => {
  return request({
    url: `/uc/api/v1/task/${taskName}`,
    method: 'get'
  });
};

/**
 * 绑定邀请码，记录uuid和码之间的关联关系
 * @param {string} params.invite_code 邀请码
*/
export const recordInviteLinkAccess = (params: { invite_code: string; }) => {
  return request({
    url: `/uc/api/v1/invite/access`,
    method: 'get',
    params
  }, {
    customError: true // 不提示错误
  });
};

/**
 * 绑定邀请码，记录uuid和码之间的关联关系
 * @param {string} data.invite_code 邀请码
*/
export const recordSpecialInviteLinkAccess = (data: { invite_code: string; }) => {
  return request({
    url: `/uc/api/v1/special-invite/access`,
    method: 'post',
    data
  }, {
    customError: true // 不提示错误
  });
};
